module.exports = __webpack_public_path__ + "img/扫码.20826fb2.jpeg";